const state = {
  callbackUrl: "",
};

const getters = {
  getCallbackUrl(state) {
    if (state.callbackUrl) {
      return state.callbackUrl
    }

    try {
      let s = localStorage.getItem("cashier_callback")
      if (s) {
        let obj = JSON.parse(s)
        if (obj && obj.callbackUrl && (Math.floor(Date.now() / 1000) - obj.ts < 43200)){
          return obj.callbackUrl
        }
      }
    } catch (e) {
      console.log(e)
    }
    return ""
  },

};

const mutations = {};

const actions = {
  SetCallbackUrl({}, callbackUrl) {
    try {
      let obj = {
        "ts": Math.floor(Date.now() / 1000),
        "callbackUrl": '' + callbackUrl,
      }
      let v = JSON.stringify(obj)
      localStorage.setItem("cashier_callback", v)
    } catch (e) {
      console.log(e)
    }
    state.callbackUrl = '' + callbackUrl
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
